import { render, staticRenderFns } from "./SplashScreenPreview.vue?vue&type=template&id=e6334b68"
import script from "./SplashScreenPreview.vue?vue&type=script&lang=js"
export * from "./SplashScreenPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports